import {
  PageTypeEnum,
  WebsitePageType,
  websitePageTypes,
} from 'common/enums/PageTypeEnum'

export const isWebsitePage = (type: PageTypeEnum): type is WebsitePageType => {
  return websitePageTypes.includes(type as WebsitePageType)
}
